<template>
  <div class="ts-menu">
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
.ts-menu {
  background: #ebecf0;
  background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
  background-blend-mode: soft-light, normal;
  background-clip: padding-box;
  border: 2px solid rgba(255, 255, 255, 0.16);
  box-shadow: -5px -5px 10px 0 rgba(250, 251, 255, 0.8), 5px 5px 10px 0 rgba(166, 171, 189, 0.48);
  border-radius: 24px;
}
</style>

<script>
export default {
  name: 'TsMenu'
};
</script>
